import { gql } from '@apollo/client'

export const EXPORT_STORAGE_QUERY = gql`
  query StorageActivities(
    $first: Int
    $after: String
    $where: StorageActivitiesGraphQlFilterInput
    $order: [StorageActivitiesGraphQlSortInput!]
  ) {
    storageActivities(first: $first, after: $after, where: $where, order: $order) {
      nodes {
        id
        code
        state
        name
        description
        temperatureConditions
        enclosure
        foodCategory
        secondaryDataReferenceSourceType
        dataQualityReliabilityScore
        referencesSamplingYear
        referenceDataPublicationYear
        referenceSourcingCountry
        referenceCountryISOCode
        referenceRegionIdentifier
        dataQualityComment
        researcherName
        researcherEmail
        isVerified
        verifiedByName
        verifiedByEmail
        verifiedOn
        verificationComments
        lastUpdatedName
        lastPublishedDate
        updated
        userId
        userEmail
        companyId
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`
